(function () {
  const grids = document.querySelectorAll(".product-grid, [data-product-grid]");

  if (!grids.length) return;

  const observer = new IntersectionObserver(
    (entries, obs) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const cards = entry.target.querySelectorAll(".product-card-wrapper");

          cards.forEach((card, index) => {
            card.style.transitionDelay = `${index * 0.08}s`;
            card.classList.add("is-visible");
          });

          obs.unobserve(entry.target);
        }
      });
    },
    { rootMargin: "0px 0px -15% 0px" },
  );

  grids.forEach((grid) => {
    const cards = grid.querySelectorAll(".product-card-wrapper");
    if (cards.length) {
      observer.observe(grid);
    }
  });
})();
